import {ROLES} from 'config/roles/roles';


export const can = (roles: ROLES[] = [], performs: ROLES[]): boolean =>
  roles.some((role) => performs.includes(role));
